export default __webpack_public_path__ + "static/media/gallery_01.eba7db28.jpg";